import get from 'lodash/get';
import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../utils/redux';

const requestOptions = {
  endpoint: 'providers',
  type: 'get',
  slug: [
    'events_feed_items',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
    {
      type: 'payload.query',
      queryParameter: 'status',
      value: 'reviewed',
    },
  ],
};

export const consts = createReqConsts('dependentManagement', 'reviewed-req', [
  'LOAD_MORE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions);

export const paginationConsts = createReqConsts(
  'dependentManagement',
  'reviewed-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
);

const initialState = {
  ...rootState,
  count: 0,
  pagination: { offset: 0, limit: 10 },
};
const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.SEND: {
      return {
        ...state,
        ...rootState,
        sending: !action.payload.silent,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        ...rootState,
        succeed: true,
        list: action.payload,
      };
    }

    case paginationConsts.SUCCEED: {
      return {
        ...state,
        list: [...state.list, ...action.payload],
      };
    }

    case paginationConsts.ADD_META:
    case consts.ADD_META: {
      return {
        ...state,
        count: get(action.payload, 'feedsCount', 0),
      };
    }

    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/dependentManagement/assignment-reviewed-req.js